// /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import {
  Box,
  createTheme,
  CssBaseline,
  Fade,
  IconButton,
  Paper,
  ThemeProvider,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import "../../index.css";
import { getSubModulesByRoleId } from "../../store";
import ChatPageCopy from "./chat-page/indexCopy";
import WelcomeScreen from "./wel-come-page/index";

import Config from "../../config/index";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const AIChatBot = ({
  defaultOpen = false,
  preDefinedPrompt = "",
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  const location = useLocation();
  const [mode, setMode] = useState(() => {
    try {
      const savedMode = localStorage.getItem("chatBotTheme");
      return savedMode ? savedMode : "light";
    } catch (error) {
      return "light";
    }
  });

  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;
  let email = loginDetails.data.email;

  let baseUrl = Config.baseUrl;
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let aiChatBotModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "c38f4dce-6ce0-4812-8a82-c55a5e28a616",
  );

  let chatAccess = aiChatBotModule
    ? aiChatBotModule.actionId.includes("2cc4aa6a-81f4-4137-9f63-445c37b8a7b8")
    : null;

  useEffect(() => {
    localStorage.setItem("chatBotTheme", mode);
  }, [mode]);

  const [showChat, setShowChat] = useState(defaultOpen);
  const [initialPrompt, setInitialPrompt] = useState(preDefinedPrompt);

  useEffect(() => {
    if (location.state?.openChat) {
      setShowChat(true);
    } else if (location.state?.resetChat) {
      setShowChat(false);
      setInitialPrompt("");
    }
  }, [location]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === "light"
            ? {
                background: {
                  default: "#f4f6f8",
                  paper: "#fff",
                  chatBot: "#f4f6f8",
                  chatUser: "#5b96f7",
                },
                text: {
                  primary: "#2C3E50",
                  secondary: "#637381",
                },
                divider: "rgba(145, 158, 171, 0.24)",
              }
            : {
                background: {
                  default: "#121212",
                  paper: "#1e1e1e",
                  chatBot: "#2d2d2d",
                  chatUser: "#90caf9",
                },
                text: {
                  primary: "#ffffff",
                  secondary: "#b0b0b0",
                },
                divider: "rgba(255, 255, 255, 0.12)",
              }),
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: { backgroundImage: "none" },
            },
          },
        },
      }),
    [mode],
  );

  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const handleStartChat = (promptText) => {
    setInitialPrompt(promptText);
    setShowChat(true);
  };

  const handleBack = () => {
    setShowChat(false);
    setInitialPrompt("");
  };

  const cardStyle = {
    width: "100%",
    maxWidth: "1400px",
    height: "100%",
    bgcolor: "background.paper",
    borderRadius: "18px",
    boxShadow:
      mode === "light"
        ? "0px 12px 24px rgba(145, 158, 171, 0.2)"
        : "0px 12px 24px rgba(0, 0, 0, 0.5)",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    p: 0,
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
  };

  const absoluteContentStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    bgcolor: "background.paper",
  };

  return (
    <DashboardLayout>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {
          <Box
            sx={{
              height: "calc(100vh - 40px)",
              mt: -1,

              bgcolor: "background.default",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "background-color 0.3s ease",
              overflow: "hidden",
              p: 0,
              fontFamily: "Arial, serif",
              borderRadius: "20px",
              "& .MuiTypography-root": { fontFamily: "Arial, serif" },
              "& .MuiInputBase-input": { fontFamily: "Arial, serif" },
            }}
          >
            <Paper elevation={0} sx={cardStyle}>
              {!showChat && (
                <Box
                  sx={{ position: "absolute", top: 16, right: 16, zIndex: 20 }}
                >
                  <IconButton
                    onClick={toggleColorMode}
                    color="inherit"
                    sx={{
                      transition: "all 0.5s ease",

                      bgcolor:
                        mode === "light"
                          ? "rgba(0,0,0,0.05)"
                          : "rgba(255,255,255,0.1)",

                      "&:hover": {
                        transform: "rotate(180deg)",

                        bgcolor:
                          mode === "light"
                            ? "rgba(0,0,0,0.1)"
                            : "rgba(255,255,255,0.2)",
                      },
                    }}
                  >
                    {theme.palette.mode === "dark" ? (
                      <LightModeRoundedIcon fontSize="small" />
                    ) : (
                      <DarkModeRoundedIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>
              )}

              <Fade in={!showChat} timeout={500} unmountOnExit>
                <Box
                  sx={{ ...absoluteContentStyle, zIndex: !showChat ? 10 : 1 }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <WelcomeScreen onStartChat={handleStartChat} />
                  </Box>
                </Box>
              </Fade>

              {chatAccess && (
                <Fade in={showChat} timeout={500} unmountOnExit>
                  <Box
                    sx={{ ...absoluteContentStyle, zIndex: showChat ? 10 : 1 }}
                  >
                    <ChatPageCopy
                      onBack={handleBack}
                      initialPrompt={initialPrompt}
                      mode={mode}
                      toggleColorMode={toggleColorMode}
                    />
                  </Box>
                </Fade>
              )}
            </Paper>
          </Box>
        }
      </ThemeProvider>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AIChatBot);
